<template>
  <div
    ref="wrap"
    class="ll-infinite-scroll-wrap"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "LlInfiniteScrollWrap",
  props: {
    searchValue: {
      type: String,
      default: "",
    },
    selectSystemSubclasses: {
      type: Array,
      default() {
        return [];
      },
    },
    page: {
      type: Number,
      default: 0,
    },
    totalPage: {
      type: Number,
      default: 0,
    },
    scrollPosition: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    scrollParam: {
      page: 1,
      totalPage: 1,
      systemIndex: 0,
      preSystemIndex: -1,
      systemSubclassIndex: 0,
      preSystemSubclassIndex: -1,
    },
  }),
  computed: {
    _allSystemClass() {
      if (!this.$store.state.model.systemClasses) {
        return [];
      } else {
        return this.$store.state.model.systemClasses;
      }
    },
    _systemClassMenu() {
      let menu = JSON.parse(JSON.stringify(this._allSystemClass));
      let menuData = menu.map((systemClass) => {
        return {
          id: systemClass.id,
          menu: systemClass.system_subclasses.map((subclass) => {
            return {
              id: subclass.id,
            };
          }),
        };
      });
      return menuData;
    },
    _allSelectSystemClass() {
      let selectSystem = [];
      this._systemClassMenu.forEach((items) => {
        let itemId = items.id;
        items.menu.forEach((item) => {
          if (this.selectSystemSubclasses.includes(item.id)) {
            if (!selectSystem.includes(itemId)) {
              selectSystem.push(itemId);
            }
          }
        });
      });
      return selectSystem;
    },
    _allSelectSubclass() {
      let selectSubclass = [];
      this._systemClassMenu.forEach((systemClass) => {
        let systemId = systemClass.id;
        systemClass.menu.forEach((subclass) => {
          if (
            this.selectSystemSubclasses.includes(subclass.id) &&
            this._allSelectSystemClass.includes(systemId)
          ) {
            selectSubclass.push(subclass.id);
          }
        });
      });
      return selectSubclass;
    },
  },
  watch: {
    totalPage: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.scrollParam.totalPage = newValue;
      },
    },
  },
  methods: {
    $_scroll() {
      this.emit("scroll");
    },
    $_initScroll() {
      this.scrollParam = {
        page: 1,
        totalPage: 1,
        systemIndex: 0,
        preSystemIndex: -1,
        systemSubclassIndex: 0,
        preSystemSubclassIndex: -1,
      };
    },
  },
};
</script>
<style lang="scss">
</style>